import { defineComponent, toRefs } from 'vue';
import { getCompanyMemberLoginHistoryPage, deactivateLogin } from '@/api/company/companyMemberApi';
import { useFetchPage, useRequestApi } from '@/composition/fetch/index';
export default defineComponent({
    name: 'LoginHistory',
    components: {
        Paging: () => import('@/components/Paging/index.vue')
    },
    props: {
        memberSeq: {
            type: [Number, String],
            required: true
        }
    },
    setup(props) {
        const { state, request, reload, changePage } = useFetchPage(getCompanyMemberLoginHistoryPage);
        request({ cmSeq: props.memberSeq });
        const { loading, data } = toRefs(state);
        const { request: deactivateLoginRequest, state: deactivateState } = useRequestApi(deactivateLogin, 0);
        const { loading: deactivateLoading } = toRefs(deactivateState);
        const headers = [
            { text: 'Date Time', value: 'registDate' },
            { text: 'Machine Name', value: 'machineName' },
            { text: 'IP', value: 'ip' },
            { text: 'Status', value: 'status', width: 160 },
            { text: 'Deactivate', value: 'deactivate', width: 200 }
        ];
        const deactivate = (loseq) => {
            return deactivateLoginRequest(loseq).finally(reload);
        };
        return {
            headers,
            data,
            loading,
            deactivateLoading,
            reload,
            deactivate,
            changePage
        };
    }
});
